/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeletePlanningResponse } from '../../models/delete-planning-response';

export interface PlanningsControllerDeletePlanning$Params {
  id: string;
}

export function planningsControllerDeletePlanning(http: HttpClient, rootUrl: string, params: PlanningsControllerDeletePlanning$Params, context?: HttpContext): Observable<StrictHttpResponse<DeletePlanningResponse>> {
  const rb = new RequestBuilder(rootUrl, planningsControllerDeletePlanning.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeletePlanningResponse>;
    })
  );
}

planningsControllerDeletePlanning.PATH = '/planning-projects/v1-preview/projects/variants/plannings/{id}';
